import AdminConfig from './admin';

import ClientView from './client';


export default {
  name : 'devisconfig',

  type : 'module',
  
  label: 'Configurateur de devis',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-file-sign',
  }
}